import React, { Component } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Badge from "react-bootstrap/Badge";
import Table from "react-bootstrap/Table";
import { Tabs, Tab } from "react-bootstrap";
import Pagination from "react-js-pagination";
import Tooltip from "react-bootstrap/Tooltip";
import DehazeIcon from "@material-ui/icons/Dehaze";
import AddSharpIcon from "@material-ui/icons/AddSharp";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { PiMagnifyingGlass } from "react-icons/pi";
import MoreVertSharpIcon from "@material-ui/icons/MoreVertSharp";
import {
  FormControl,
  Button,
  InputGroup,
  Form,
  Dropdown,
} from "react-bootstrap";

import axiosRequest from "axios";
import axios from "../../../axios";
import apiError from "../../../error";
import { getDate, getCookie } from "../../../function";
import CampaignPreview from "../../../component/create-template/campaign-preview/campaign-preview";
import LaunchNewModal from "../../../component/launch-modal/launch-new-modal";
import NewCampaignTemplateFilter from "../../../component/create-template/campaign-template-filter/new-campaign-template-filter";
import Vishing from "../../../assets/campaign-thumbnail-vishing.png";
import Phishing from "../../../assets/campaign-thumbnail-phishing.png";
import Smishing from "../../../assets/campaign-thumbnail-smishing.png";
import WhatsApp from "../../../assets/campaign-thumbnail-whatsapp.png";
import Ransomware from "../../../assets/campaign-thumbnail-ransomware.png";
import Telegram from "../../../assets/campaign-thumbnail-whatsapp.png";


import "./campaign-template.css";
import { featuresObj } from "../../../globalData";
import DebouncedLoader from "../../../component/loader/debounced-loader";

var cancelRequest = undefined,
  CancelToken = axiosRequest.CancelToken;

/** List view: show at most this many characters, then "..." (full name in title). */
const CAMPAIGN_TEMPLATE_LIST_NAME_MAX_LEN = 45;

function truncateCampaignTemplateListName(name, maxLen = CAMPAIGN_TEMPLATE_LIST_NAME_MAX_LEN) {
  if (name == null || name === "") return "";
  const s = String(name);
  if (s.length <= maxLen) return s;
  return s.slice(0, maxLen) + "...";
}

/**
 * Align launch prefill with campaign-preview / edit: same Vishing TIT + isAIbased rules and category from full template.
 */
function buildLaunchStateFromCampaignTemplate(campaignTemplate) {
  if (!campaignTemplate) {
    return {
      attackType: "",
      simulationType: "",
      credentialHarvesting: false,
      categoryId: "",
      targetInteractionType: "",
      isAIbased: false,
    };
  }
  const attackName = campaignTemplate.attack_type
    ? campaignTemplate.attack_type.name
    : "";
  const titRaw = campaignTemplate.targetInteractionType;
  const normalizedTitRaw =
    titRaw != null ? String(titRaw).trim().toLowerCase() : "";
  let derivedIsAI = campaignTemplate.isAIbased;
  if (derivedIsAI !== true && derivedIsAI !== false && normalizedTitRaw !== "") {
    if (normalizedTitRaw === "inbound") derivedIsAI = true;
    else if (normalizedTitRaw === "outbound") derivedIsAI = false;
  }
  if (derivedIsAI !== true && derivedIsAI !== false) derivedIsAI = false;
  let normalizedTargetInteractionType = campaignTemplate.targetInteractionType;
  if (attackName === "Vishing" || attackName === "WhatsApp") {
    if (normalizedTitRaw === "inbound" || normalizedTitRaw === "outbound") {
      normalizedTargetInteractionType = normalizedTitRaw;
      derivedIsAI = normalizedTitRaw === "inbound";
    } else {
      normalizedTargetInteractionType = derivedIsAI ? "inbound" : "outbound";
    }
  }
  const sim = campaignTemplate.simulation_type;
  const simulationType =
    typeof sim === "string"
      ? sim
      : sim && sim.name
        ? sim.name
        : "";
  const rawCat =
    campaignTemplate.category != null
      ? campaignTemplate.category.id
      : campaignTemplate.categoryId;
  const categoryId =
    rawCat != null && rawCat !== "" ? String(rawCat) : "";
  return {
    attackType: attackName,
    simulationType,
    credentialHarvesting: !!campaignTemplate.credential_harvesting,
    categoryId,
    targetInteractionType: normalizedTargetInteractionType || "",
    isAIbased: !!derivedIsAI,
  };
}

export default class CampaignTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      limit: 10,
      search: "",
      isType: true,
      loading: true,
      languages: [],
      languageId: [],
      imagePath: "",
      categoryId: [],
      categories: [],
      categoryIds: [],
      attackTypeId: [],
      attackTypes: [],
      campaignTemplates: [],
      type: "My Templates",
      userAgent: getCookie("userAgent"),
      withTraining: false,
      showFilter: false,
      showPreview: false,
      openTestOnPreviewOpen: false,
      showLaunchNewModal: false,
      campaignTemplateId: null,
      campaignType: "",
      launchAttackType: "",
      launchSimulationType: "",
      launchCredentialHarvesting: false,
      launchCategoryId: "",
      launchCampaignTemplateId: null,
      launchTargetInteractionType: "",
      launchIsAIbased: false,
      templateFeature: {},
      aiTemplateFeature: featuresObj["ai-template"],
      permissibleActionsIAM: {},
      selectedTemplateType: "My Templates",
      selectedLanguageName: "",
      selectedAttackTypeName: "",
      selectedCategoryIds: [],
      selectedCategoryId: [],
      selectedAttackId: "",
      selectedLanguageId: "",
      key: "system",
      credentialHarvesting: false,
      status: "",
      /** WhatsApp template subtype chips: all | direct | ai */
      whatsappTemplateFilter: "all",
      /** Vishing template subtype chips: all | ivr | ai (same TIT + isAIbased semantics as WhatsApp chips) */
      vishingTemplateFilter: "all",
    };
  }

  /** List comes from API; WhatsApp chip filters are passed as load() params. */
  getFilteredCampaignTemplates = () => this.state.campaignTemplates || [];

  /**
   * Query params for WhatsApp template-type chips (only when WhatsApp is the sole attack filter).
   * All: both null. Direct: outbound / false. AI conversational: inbound / true.
   */
  getWhatsappTemplateLoadFilters = () => {
    if (!this.isWhatsAppOnlyAttackFilter()) {
      return { targetInteractionType: null, isAIbased: null };
    }
    const mode = this.state.whatsappTemplateFilter || "all";
    if (mode === "all") {
      return { targetInteractionType: null, isAIbased: null };
    }
    if (mode === "direct") {
      return { targetInteractionType: "outbound", isAIbased: false };
    }
    if (mode === "ai") {
      return { targetInteractionType: "inbound", isAIbased: true };
    }
    return { targetInteractionType: null, isAIbased: null };
  };

  /**
   * Query params for Vishing template-type chips (only when Vishing is the sole attack filter).
   * All: both null. IVR: outbound / false. AI voice bot: inbound / true.
   */
  getVishingTemplateLoadFilters = () => {
    if (!this.isVishingOnlyAttackFilter()) {
      return { targetInteractionType: null, isAIbased: null };
    }
    const mode = this.state.vishingTemplateFilter || "all";
    if (mode === "all") {
      return { targetInteractionType: null, isAIbased: null };
    }
    if (mode === "ivr") {
      return { targetInteractionType: "outbound", isAIbased: false };
    }
    if (mode === "ai") {
      return { targetInteractionType: "inbound", isAIbased: true };
    }
    return { targetInteractionType: null, isAIbased: null };
  };

  /**
   * Show WhatsApp template-type chips only when WhatsApp is the sole attack filter.
   * Hide when user selects WhatsApp together with Ransomware, Vishing, etc.
   */
  isWhatsAppOnlyAttackFilter = () => {
    const rawIds = Array.isArray(this.state.attackTypeId)
      ? this.state.attackTypeId
      : this.state.attackTypeId
        ? [this.state.attackTypeId]
        : [];
    const selectedIds = [...new Set(rawIds)];
    if (!selectedIds.length || !this.state.attackTypes?.length) {
      return false;
    }
    const resolved = selectedIds
      .map((id) =>
        this.state.attackTypes.find((at) => String(at.id) === String(id))
      )
      .filter(Boolean);
    if (resolved.length !== selectedIds.length) {
      return false;
    }
    return resolved.every((at) => at.name === "WhatsApp");
  };

  /**
   * Show Vishing template-type chips only when Vishing is the sole attack filter.
   */
  isVishingOnlyAttackFilter = () => {
    const rawIds = Array.isArray(this.state.attackTypeId)
      ? this.state.attackTypeId
      : this.state.attackTypeId
        ? [this.state.attackTypeId]
        : [];
    const selectedIds = [...new Set(rawIds)];
    if (!selectedIds.length || !this.state.attackTypes?.length) {
      return false;
    }
    const resolved = selectedIds
      .map((id) =>
        this.state.attackTypes.find((at) => String(at.id) === String(id))
      )
      .filter(Boolean);
    if (resolved.length !== selectedIds.length) {
      return false;
    }
    return resolved.every((at) => at.name === "Vishing");
  };

  handleSelect = (key) => {
    this.setState({ key });
  };

  componentDidMount = () => {
    this.checkValidToken();
    this.loadPermissibleActions();
    // this.fetchAITemplateFeature();
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isPackageFetched !== prevProps.isPackageFetched &&
      this.props.isPackageFetched
    ) {
      this.setState({ aiTemplateFeature: featuresObj["ai-template"] });
    }
    if (this.state.languageId !== prevState.languageId || this.state.categoryId !== prevState.categoryId || this.state.attackTypeId !== prevState.attackTypeId || this.state.status !== prevState.status) {
      this.load();
    }
    if (this.state.key !== prevState.key) {
      if (this.state.key === "system") {
        this.loadStoreCategory();
        this.loadStoreLanguage();
      } else {
        this.loadCategory();
        this.loadLanguage();
      }
      this.setState({ languageId: [], categoryIds: [], attackTypeId: [], search: "", credentialHarvesting: false, limit: 10, status: "" }, () => {
        this.load();
      })
    }
    if (this.state.attackTypeId !== prevState.attackTypeId) {
      if (!this.isWhatsAppOnlyAttackFilter() && this.state.whatsappTemplateFilter !== "all") {
        this.setState({ whatsappTemplateFilter: "all" });
      }
      if (!this.isVishingOnlyAttackFilter() && this.state.vishingTemplateFilter !== "all") {
        this.setState({ vishingTemplateFilter: "all" });
      }
    }
  }

  checkValidToken = () => {
    axios
      .post("/api/auth/check-token", {})
      .then((res) => {
        this.load();
        this.loadStoreCategory();
        this.loadStoreLanguage();
        this.loadAttackType();
      })
      .catch((err) => apiError(err));
  };

  loadAttackType = () => {
    axios
      .get("/api/attacktypes", {})
      .then((res) => {
        this.setState({ attackTypes: res.data.attackTypes });
      })
      .catch((err) => apiError(err));
  };

  //debouncing not applied here because api is already taking a lot of time to fetch response, cancel token would be perfect for this
  load = () => {
    this.setState({ loading: true }); // Set loading to true at the start of the request
    if (cancelRequest) cancelRequest();
    const wa = this.getWhatsappTemplateLoadFilters();
    const vi = this.getVishingTemplateLoadFilters();
    const modeFilters = this.isWhatsAppOnlyAttackFilter()
      ? wa
      : this.isVishingOnlyAttackFilter()
        ? vi
        : { targetInteractionType: null, isAIbased: null };
    axios
      .get((this.state.key === "system" ? "/api/store/fetch-store-system-templates" : "/api/campaign/template"), {
        params: {
          type: this.state.type, // here the type doesn't matter, (this.state.key is used to judge the system template or the custom template)
          limit: this.state.limit,
          search: this.state.search,
          page: this.state.activePage,
          languageIds: this.state.languageId,
          categoryIds: this.state.categoryIds,
          attackTypeIds: this.state.attackTypeId,
          status: this.state.status === "all" ? "" : this.state.status,
          withTraining: this.state.withTraining,
          credentialHarvesting: this.state.credentialHarvesting,
          targetInteractionType: modeFilters.targetInteractionType,
          isAIbased: modeFilters.isAIbased,
        },
        cancelToken: new CancelToken(function executor(c) {
          cancelRequest = c;
        }),
      })
      .then((res) => {
        this.setState({
          loading: false,
          count: res.data.count,
          imagePath: res.data.path,
          campaignTemplates: res.data.campaign_templates,
        });
      })
      .catch((error) => {
        if (!axiosRequest.isCancel(error)) {
          this.setState({ campaigns: [], count: 0, loading: false, campaignTemplates: [] });
          apiError(error);
        }
      });
  };

  loadCategory = () => {
    axios
      .get("/api/campaign/template/category", {})
      .then((res) => {
        let categoryValue = [];
        for (var i = 0; i < res.data.categories.length; i++) {
          categoryValue.push({
            label: res.data.categories[i].name,
            value: res.data.categories[i].id,
          });
        }
        this.setState({ categories: categoryValue });
      })
      .catch((err) => apiError(err));
  };

  loadLanguage = () => {
    axios
      .get("/api/campaign/template/language", {})
      .then((res) => {
        this.setState({ languages: res.data.languages });
      })
      .catch((err) => apiError(err));
  };

  loadStoreCategory = () => {
    axios.get("/api/store/fetch-categories", {})
      .then((res) => {
        let categoryValue = [];
        for (var i = 0; i < res.data.response.length; i++) {
          categoryValue.push({
            label: res.data.response[i].name,
            value: res.data.response[i].id,
          });
        }
        this.setState({ categories: categoryValue });
      })
      .catch(err => console.log(err));
  };
  loadStoreLanguage = () => {
    axios.get("/api/store/fetch-languages", {})
      .then((res) => {
        this.setState({ languages: res.data.response });
      })
      .catch(err => console.log(err));
  };

  nextPath = (path) => {
    this.props.history.push(path);
  };

  handleCategory = (e) => {
    let categoryIds = [];
    for (let i = 0; i < e.length; i++) {
      categoryIds.push(e[i].value);
    }
    this.setState({ categoryIds: categoryIds, categoryId: e, activePage: 1 });
  };

  deleteCampaignTemplate = (campaignTemplateId) => {
    swal({
      title: "Do you want to delete CampaignTemplate?",
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    }).then((willSuccess) => {
      if (willSuccess) {
        axios
          .delete("/api/campaign/template/" + campaignTemplateId, {})
          .then((r) => {
            toast.success("CampaignTemplate deleted successfully");
            this.load();
          })
          .catch((error) => {
            apiError(error);
          });
      }
    });
  };

  copyCampaignTemplate = (campaignTemplateId) => {
    swal({
      title: "Do you want to clone CampaignTemplate?",
      icon: "info",
      buttons: ["No", "Yes"],
    }).then(async (willSuccess) => {
      if (willSuccess) {
        await this.setState({ loading: true });
        let backendApiUrl = this.state.key === "system" ? "/api/store/clone-campaign-template/" : "/api/campaign/template/clone/";
        axios
          .post(backendApiUrl + campaignTemplateId, { forceNew: true })
          .then((res) => {
            this.load();
            this.setState({ loading: false });
            toast.success("Campaign Template Added Successfully");
            this.handleSelect('templates');
          })
          .catch((error) => {
            this.setState({ loading: false });
            apiError(error);
          });
      }
    });
  };

  launchCampaignTemplate = (campaign) => {
    const id = campaign?.id;
    if (id == null) return;
    this.setState({ loading: true });
    const previewBase =
      this.state.key === "system"
        ? "/api/store/fetch-system-template/preview/"
        : "/api/campaign/template/preview/";
    axios
      .get(previewBase + parseInt(id, 10), {})
      .then((res) => {
        const ct = res.data.campaign_template;
        const launch = buildLaunchStateFromCampaignTemplate(ct);
        this.setState({
          loading: false,
          showLaunchNewModal: true,
          launchAttackType: launch.attackType,
          launchSimulationType: launch.simulationType,
          launchCredentialHarvesting: launch.credentialHarvesting,
          launchCategoryId: launch.categoryId,
          launchCampaignTemplateId: id,
          launchTargetInteractionType: launch.targetInteractionType,
          launchIsAIbased: launch.isAIbased,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        apiError(error);
      });
  };

  handleCategoryRemove = (categoryId) => {
    let index = this.state.categoryIds.indexOf(categoryId);
    if (index > -1) {
      let cId = this.state.categoryId;
      let categoryIds = this.state.categoryIds;
      cId = cId.filter((data) => categoryId !== data.value);
      categoryIds.splice(index, 1);
      this.setState(
        {
          categoryIds,
          categoryId: cId ?? [],
          selectedCategoryIds: categoryIds,
          selectedCategoryId: cId || [],
        },
        () => {
          this.load();
        }
      );
    }
  };

  // fetchAITemplateFeature = async() => {
  // 	try{
  // 		let res = await axios.get("/api/package/ai-template", {});
  // 		this.setState({aiTemplateFeature: res.data.isFeatureExists});
  // 	}catch(error){
  // 		apiError(error);
  // 	}
  // }
  loadPermissibleActions = async () => {
    try {
      let permissibleActions = await axios.post("/api/iam-user/permissions", {
        actions: [
          "campaign-write",
          "setting-read",
          "user-and-department-read",
          "campaign-template-read",
          "campaign-template-write",
        ],
      });
      this.setState({
        permissibleActionsIAM: permissibleActions.data.permissibleObj,
      });
    } catch (error) {
      console.log(
        "Error occured while fetching permissibleActionsIAM: ",
        error
      );
    }
  };
  handleTemplateFilter = async () => {
    try {
      this.load();
      let languageName = null;
      const selectedLangIds = Array.isArray(this.state.languageId) ? this.state.languageId : (this.state.languageId ? [this.state.languageId] : []);
      const selectedAttackIds = Array.isArray(this.state.attackTypeId) ? this.state.attackTypeId : (this.state.attackTypeId ? [this.state.attackTypeId] : []);
      const languageNames = [];
      this.state.languages.forEach((lang) => {
        if (selectedLangIds.includes(lang.id)) {
          languageNames.push(lang.name);
        }
      });
      const attackTypeNames = [];
      this.state.attackTypes.forEach((attack) => {
        if (selectedAttackIds.includes(attack.id)) {
          attackTypeNames.push(attack.name);
        }
      });
      languageName = languageNames.length ? languageNames.join(", ") : null;
      let attackTypeName = attackTypeNames.length ? attackTypeNames.join(", ") : null;
      this.setState({
        showFilter: false,
        selectedTemplateType: this.state.key === "system" ? "System Templates" : "My Templates",
        selectedAttackTypeName: attackTypeName,
        selectedLanguageName: languageName,
        selectedCategoryIds: this.state.categoryIds,
        selectedCategoryId: this.state.categoryId,
        selectedAttackId: selectedAttackIds,
        selectedLanguageId: selectedLangIds,
      });
    } catch (error) {
      console.log("Error occured while applying template filter: ", error);
    }
  };
  // handleShowFilter = (showFilter = true) => {
  //   this.setState({
  //     showFilter: showFilter,
  //     type: this.state.selectedTemplateType || "My Templates",
  //     categoryIds: this.state.selectedCategoryIds,
  //     categoryId: this.state.selectedCategoryId,
  //     attackTypeId: this.state.selectedAttackId,
  //     languageId: this.state.selectedLanguageId,
  //   });
  // };
  handleLimit = (newLimit) => {
    if (newLimit !== this.state.limit) {
      this.setState({ limit: newLimit }, () => {
        this.load();
      });
    }
  }

  handleClearFilter = () => {
    this.setState({
      languageId: [],
      categoryId: [],
      categoryIds: [],
      attackTypeId: [],
      search: "",
      limit: 10,
      activePage: 1,
      status: ""
    }, () => {
      this.load(); // Call API after state is reset
    });
  }

  render() {
    let languageName = null;
    const selectedLangIds = Array.isArray(this.state.languageId) ? this.state.languageId : (this.state.languageId ? [this.state.languageId] : []);
    const selectedAttackIds = Array.isArray(this.state.attackTypeId) ? this.state.attackTypeId : (this.state.attackTypeId ? [this.state.attackTypeId] : []);
    const languageNames = [];
    const attackTypeNames = [];
    this.state.languages.forEach((lang) => {
      if (selectedLangIds.includes(lang.id)) {
        languageNames.push(lang.name);
      }
    });
    this.state.attackTypes.forEach((attack) => {
      if (selectedAttackIds.includes(attack.id)) {
        attackTypeNames.push(attack.name);
      }
    });
    languageName = languageNames.length ? languageNames.join(", ") : null;
    let attackTypeName = attackTypeNames.length ? attackTypeNames.join(", ") : null;
    return (
      <div className="content-wrap">
        <div className="breadcrumbbar">
          <div className="flexRow row">
            <div className="col-md-4">
              <div className="page-head d-flex align-items-center justify-content-between">
                <h4 className="page-title">Campaign Templates</h4>
              </div>
            </div>

            <div className="col-md-8 flexFilterButtons">
              <div className="btn-container float-right d-flex align-items-center">
                <OverlayTrigger
                  placement="top"
                  overlay={
                    this.state.aiTemplateFeature ? (
                      this.state.permissibleActionsIAM[
                        "campaign-template-write"
                      ] ? (
                        <Tooltip id="top" className="d-none" />
                      ) : (
                        <Tooltip id="top">
                          You don't have permission to access
                        </Tooltip>
                      )
                    ) : (
                      <Tooltip id="top">Upgrade your plan</Tooltip>
                    )
                  }
                >
                  <Button
                    variant="secondary"
                    onClick={(e) => {
                      if (
                        this.state.aiTemplateFeature &&
                        this.state.permissibleActionsIAM[
                        "campaign-template-write"
                        ]
                      ) {
                        this.nextPath("/templates/ai");
                      } else {
                        e.preventDefault(); // Prevent clicks when not allowed
                      }
                    }}
                    className={`mr-2 ${!this.state.aiTemplateFeature ? "disabledCls2" : ""
                      }`}
                  >
                    <AddSharpIcon className="btn-icon" /> AI Template{" "}
                    <sup>(Beta)</sup>
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  overlay={
                    this.state.permissibleActionsIAM[
                      "campaign-template-write"
                    ] ? (
                      <Tooltip id="top" className="d-none" />
                    ) : (
                      <Tooltip id="top">
                        You don't have permission to access
                      </Tooltip>
                    )
                  }
                >
                  <Button
                    variant="primary"
                    onClick={() =>
                      this.state.permissibleActionsIAM[
                      "campaign-template-write"
                      ] && this.nextPath("/templates/0")
                    }
                  >
                    <AddSharpIcon className="btn-icon"></AddSharpIcon>Create
                    Template
                  </Button>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        </div>

        <div className="contentbar">

          <div className="new-filter-wrapper">
            <div className="row">
              <div className="col-md-8">
                <div className="tab-wrapper">
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={this.handleSelect}
                  >
                    <Tab eventKey="system" title="System" />
                    <Tab eventKey="templates" title="My Templates" />
                  </Tabs>

                </div>


              </div>
              <div className="col-md-4 ">
                <div className="rightFilters">
                  <div className="positionSearchIcon">
                    <InputGroup className="search-wrap">
                      <FormControl
                        type="text"
                        placeholder="Search"
                        value={this.state.search}
                        onChange={(e) =>
                          this.setState(
                            { search: e.target.value, activePage: 1 },
                            () => this.load()
                          )
                        }
                        className="inputSearch mr-sm-2 form-control"
                      />
                      <PiMagnifyingGlass className="search-icon"></PiMagnifyingGlass>
                    </InputGroup>
                  </div>
                  <Dropdown className="d-inline-block">
                    <Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white mr-2">
                      {this.state.limit}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {[10, 20, 50, 100].map((limit) => (
                        <Dropdown.Item
                          key={`limit-${limit}`}
                          onClick={() => this.setState({ limit: limit, activePage: 1 }, () => this.load())}
                          active={this.state.limit === limit}
                        >
                          {limit}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  <div className="sort-filter-btn">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="view-toggle-tooltip">
                          {this.state["isType"] ? "Switch to List View" : "Switch to Grid View"}
                        </Tooltip>
                      }
                    >
                      <Button
                        variant="secondary"
                        onClick={() => this.setState({ isType: !this.state["isType"] })}
                        className="view-toggle-btn"
                      >
                        {this.state["isType"] ? (
                          <ViewModuleIcon
                            style={{
                              fontSize: "22px",
                              transition: "opacity 0.3s ease, transform 0.3s ease",
                            }}
                          />
                        ) : (
                          <DehazeIcon
                            style={{
                              fontSize: "22px",
                              transition: "opacity 0.3s ease, transform 0.3s ease",
                            }}
                          />
                        )}
                      </Button>
                    </OverlayTrigger>
                  </div>

                </div>

              </div>

            </div>


          </div>
          {/* =====Vertical layout Common Grid======  */}

          <div className="row">
            <div className="col-md-3">
              <div className="leftVerticalFilters">
                <NewCampaignTemplateFilter
                  show={this.state.showFilter}
                  type={this.state.key === "system" ? "System Templates" : "My Templates"}
                  attackTypes={this.state.attackTypes}
                  attackTypeId={this.state.attackTypeId}
                  languages={this.state.languages}
                  languageId={this.state.languageId}
                  categories={this.state.categories}
                  categoryId={this.state.categoryId}
                  status={this.state.status}
                  handleCategory={this.handleCategory}
                  handleTemplateType={(type) => {
                    this.setState({ type, activePage: 1 });
                  }}
                  handleLanguage={(languageId) => {
                    this.setState({ languageId, activePage: 1 });
                  }}
                  handleAttackType={(attackTypeId) => {
                    this.setState({ attackTypeId, activePage: 1 });
                  }}
                  handleStatus={(status) => {
                    this.setState({ status, activePage: 1 });
                  }}
                  handleClearFilter={this.handleClearFilter}  // Add this line
                  showHandle={() => this.setState({ showFilter: false })}
                  handleTemplateFilter={this.handleTemplateFilter}
                  handleLimit={this.handleLimit}
                  limit={this.state.limit}
                />
                {/* "Simulation + Training" and "Credential Harvesting" filters removed —
                    templates are "Simulation Attack" only and CH is a campaign-level setting. */}

              </div>

            </div>
            <div className="col-md-9 pl-0">
              <div className="page-content p-0" style={{ height: 'calc(100vh - 270px)', overflowY: 'auto' }}>
                {this.isWhatsAppOnlyAttackFilter() ? (
                  <div className="row m-0">
                    <div className="template-type-filter-box">
                      <span className="template-type-filter-label">Template type :</span>
                      <div className="template-type-filter-chips" role="group" aria-label="Template type">
                        {[
                          { id: "all", label: "All" },
                          { id: "direct", label: "Direct Whatsapp Message" },
                          { id: "ai", label: "AI Conversational (Chat Bot)" },
                        ].map((opt) => (
                          <button
                            key={opt.id}
                            type="button"
                            className={
                              "template-type-filter-chip" +
                              (this.state.whatsappTemplateFilter === opt.id
                                ? " is-active"
                                : "")
                            }
                            onClick={() =>
                              this.setState(
                                { whatsappTemplateFilter: opt.id, activePage: 1 },
                                () => this.load()
                              )
                            }
                          >
                            {opt.label}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : this.isVishingOnlyAttackFilter() ? (
                  <div className="row m-0">
                    <div className="template-type-filter-box">
                      <span className="template-type-filter-label">Template type :</span>
                      <div className="template-type-filter-chips" role="group" aria-label="Vishing template type">
                        {[
                          { id: "all", label: "All" },
                          { id: "ivr", label: "IVR (Keypad-based)" },
                          { id: "ai", label: "AI Conversational (Voice Bot)" },
                        ].map((opt) => (
                          <button
                            key={opt.id}
                            type="button"
                            className={
                              "template-type-filter-chip" +
                              (this.state.vishingTemplateFilter === opt.id
                                ? " is-active"
                                : "")
                            }
                            onClick={() =>
                              this.setState(
                                { vishingTemplateFilter: opt.id, activePage: 1 },
                                () => this.load()
                              )
                            }
                          >
                            {opt.label}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : null}


                {this.state.isType ? (
                  <div className="row m-0">
                    {this.state.campaignTemplates.length ? (
                      this.getFilteredCampaignTemplates().length ? (
                        this.getFilteredCampaignTemplates().map((campaign, index) => {
                      const image =
                        campaign.template && campaign.template.thumbnailUrl
                          ? campaign.template.thumbnailUrl
                          : null;
                      return (
                        <div className="col-md-3 tempCard" key={"grid-" + index}>
                          <div className="Campaign-Card-Box">
                            <div className="Card-img-link">
                              <div
                                className="cardImg addCursor"
                                onClick={() => {
                                  this.setState({
                                    showPreview: true,
                                    campaignType: campaign.type,
                                    campaignTemplateId: campaign.id,
                                  });
                                }}
                              >
                                <img
                                  alt="template"
                                  className="img-fluid"
                                  src={
                                    campaign.attack_type.name !== "WhatsApp" &&
                                      image
                                      ? image
                                      : campaign.attack_type.name === "Phishing"
                                        ? Phishing
                                        : campaign.attack_type.name === "Smishing"
                                          ? Smishing
                                          : campaign.attack_type.name === "Ransomware"
                                            ? Ransomware
                                            : campaign.attack_type.name === "WhatsApp"
                                              ? WhatsApp
                                              : campaign.attack_type.name === "Telegram"
                                                ? Telegram
                                                : Vishing
                                  }
                                ></img>

                                {campaign.status === "draft" && (
                                  <Badge variant={"primary"} className="badge-secondary status-badge-position-right">
                                    {campaign.status}
                                  </Badge>
                                )}
                              </div>
                            </div>
                            <div className="cardFooter">
                              <div className="cardBody" style={{ borderBottom: 'unset', paddingBottom: '0px' }}>
                                <div className="titleName">
                                  <h2
                                    className="addCursor"
                                    onClick={() => {
                                      this.setState({
                                        showPreview: true,
                                        campaignType: campaign.type,
                                        campaignTemplateId: campaign.id,
                                      });
                                    }}
                                  >
                                    {campaign.name}
                                  </h2>
                                  <h6>{getDate(campaign.createdAt)}</h6>
                                </div>

                                <h2
                                  className="addCursor"
                                  onClick={() => {
                                    this.setState({
                                      showPreview: true,
                                      campaignType: campaign.type,
                                      campaignTemplateId: campaign.id,
                                    });
                                  }}
                                >
                                </h2>
                              </div>

                              <div className="cardfooterBox">
                                <Badge className="badge badgeOne">
                                  {campaign.attack_type.name + ""}
                                </Badge>
                                <Badge className="badge badgeTwo">
                                  {/* {campaign.type === "My Templates"
                                    ? "Custom Template"
                                    : campaign.type} */}
                                  {/* Templates surface only "Simulation Attack" (never "+ Training") */}
                                  {/* {campaign?.simulation_type?.name === "Simulation Attack + Training" ? "Simulation Attack" : (campaign?.simulation_type?.name ?? "")} */}
                                </Badge>

                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                      ) : (
                        <p className="text-center col-12">No templates match the selected type.</p>
                      )
                    ) : (
                      <p className="text-center col-12">No {this.state.key === "system" ? "System Templates" : "My Templates"} Found.</p>
                    )}
                  </div>
                ) : (
                  <div className="tableContainerWrapInner">
                    <Table>
                      <thead>
                        <tr>
                          <th className="th-30">Name</th>
                          <th>Initiated on</th>
                          <th>category</th>
                          <th>Attack type</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {this.state.campaignTemplates.length ? (
                          this.getFilteredCampaignTemplates().length ? (
                            this.getFilteredCampaignTemplates().map((campaign, index) => {
                          const image =
                            campaign.template && campaign.template.thumbnailUrl
                              ? campaign.template.thumbnailUrl
                              : null;
                          return (
                            <tr key={"list-" + index}>
                              <td className="onlyForPinter campaign-template-name-td">
                                <div className="flexTableData campaign-template-name-row">
                                  <div className="companyLogoIcon">
                                    <img
                                      alt="template"
                                      className="img-fluid"
                                      src={
                                        campaign.attack_type.name !== "WhatsApp" &&
                                          image
                                          ? image
                                          : campaign.attack_type.name === "Phishing"
                                            ? Phishing
                                            : campaign.attack_type.name === "Smishing"
                                              ? Smishing
                                              : campaign.attack_type.name ===
                                                "Ransomware"
                                                ? Ransomware
                                                : campaign.attack_type.name === "Telegram"
                                                  ? Telegram
                                                  : campaign.attack_type.name === "WhatsApp"
                                                    ? WhatsApp
                                                    : Vishing
                                      }
                                    ></img>
                                  </div>
                                  <div
                                    className="campaign-template-name-ellipsis"
                                    title={campaign.name || ""}
                                  >
                                    <h6 className="campaign-template-name-h6">
                                      {truncateCampaignTemplateListName(
                                        campaign.name
                                      )}
                                    </h6>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="timeBox">
                                  <p>{getDate(campaign.createdAt)}</p>
                                </div>
                              </td>
                              <td>
                                <span className="badge secondaryBadge">
                                  {campaign.type === "My Templates"
                                    ? "Custom Template"
                                    : campaign.type}
                                </span>
                              </td>
                              {/* Credential Harvesting column removed — campaign-level setting now. */}
                              <td>
                                <span className="badge primaryBadge">
                                  {" "}
                                  {campaign.attack_type.name + ""}
                                </span>
                              </td>
                              <td>
                                <div className="col-md-1" ref={this.selectRef}>
                                  <Dropdown className="action-dropdown dropdownIcon">
                                    <Dropdown.Toggle
                                      className="btn-only"
                                      id="dropdown-basic"
                                    >
                                      <MoreVertSharpIcon className="dot-icon"></MoreVertSharpIcon>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      {campaign.type === "My Templates" ? (
                                        <Dropdown.Item
                                          onClick={(e) =>
                                            this.nextPath(
                                              "/templates/" + campaign.id
                                            )
                                          }
                                        >
                                          {" "}
                                          Edit{" "}
                                        </Dropdown.Item>
                                      ) : null}
                                      <Dropdown.Item
                                        onClick={() => {
                                          this.setState({
                                            showPreview: true,
                                            campaignType: campaign.type,
                                            campaignTemplateId: campaign.id,
                                          });
                                        }}
                                      >
                                        Preview
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        onClick={(e) =>
                                          this.copyCampaignTemplate(campaign.id)
                                        }
                                      >
                                        Clone
                                      </Dropdown.Item>
                                      {this.state.key !== "system" &&
                                        <Dropdown.Item
                                          onClick={(e) =>
                                            this.launchCampaignTemplate(campaign)
                                          }
                                        >
                                          Create Campaign
                                        </Dropdown.Item>
                                      }
                                      {campaign.type === "My Templates" ? (
                                        <Dropdown.Item
                                          onClick={(e) =>
                                            this.deleteCampaignTemplate(campaign.id)
                                          }
                                        >
                                          Delete
                                        </Dropdown.Item>
                                      ) : null}

                                        {campaign.type === "My Templates" ? (
                                        campaign.status === "draft" ? (
                                          <OverlayTrigger
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`test-draft-tooltip-${campaign.id}`}>
                                                Draft templates cannot be tested
                                              </Tooltip>
                                            }
                                          >
                                            <span className="d-inline-block w-100">
                                              <Dropdown.Item
                                                disabled
                                                style={{ pointerEvents: "none" }}
                                              >
                                                Test Template
                                              </Dropdown.Item>
                                            </span>
                                          </OverlayTrigger>
                                        ) : (
                                          <Dropdown.Item
                                            onClick={(e) =>
                                              this.setState({
                                                showPreview: true,
                                                campaignType: campaign.type,
                                                campaignTemplateId: campaign.id,
                                                openTestOnPreviewOpen: true,
                                              })
                                            }
                                          >
                                            Test Template
                                          </Dropdown.Item>
                                        )
                                      ) : null}
                                    </Dropdown.Menu>

                                    
                                  </Dropdown>
                                </div>
                              </td>
                            </tr>
                          );
                            })
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No templates match the selected type.
                              </td>
                            </tr>
                          )
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No Templates Found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                )}
              </div>

              {this.state.count > 0 && (
                <div className="pagination-Wrap fixedBottomFooter">
                  <div className="row">
                    <div className="col-md-6">
                      {!this.state["loading"] ? (
                        <Pagination
                          itemClass="page-item"
                          linkClass="page-link"
                          activePage={this.state.activePage}
                          itemsCountPerPage={this.state.limit}
                          totalItemsCount={this.state.count}
                          onChange={(pageNumber) =>
                            this.setState({ activePage: pageNumber }, () =>
                              this.load()
                            )
                          }
                        />
                      ) : (
                        <DebouncedLoader loading={this.state.loading} />
                      )}
                    </div>
                    <div className="col-md-6 text-right d-flex align-items-center footer-pg">
                      <div className="w-100 pgCount">
                        <p> {this.state.count} Templates Available</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>




          <DebouncedLoader loading={this.state.loading} />
          {this.state.showPreview ? (
            <CampaignPreview
              load={this.load}
              nextPath={this.nextPath}
              show={this.state.showPreview}
              campaignTemplateId={this.state.campaignTemplateId}
              campaignType={this.state.campaignType}
              openTestOnOpen={this.state.openTestOnPreviewOpen}
              handleModal={() => this.setState({ showPreview: false, openTestOnPreviewOpen: false })}
              keyType={this.state.key}
              handleKeySelect={this.handleSelect}
            ></CampaignPreview>
          ) : (
            ""
          )}
          <LaunchNewModal
            showModal={this.state.showLaunchNewModal}
            showHandle={() => this.setState({ showLaunchNewModal: false })}
            nextPath={this.nextPath}
            campaignTemplateId={this.state.launchCampaignTemplateId}
            attackType={this.state.launchAttackType}
            simulationType={this.state.launchSimulationType}
            credentialHarvesting={this.state.launchCredentialHarvesting}
            categoryId={this.state.launchCategoryId}
            prefilledFromTemplate={!!(
              this.state.launchAttackType &&
              this.state.launchCampaignTemplateId
            )}
            targetInteractionType={this.state.launchTargetInteractionType}
            isAIbased={this.state.launchIsAIbased}
          />
        </div>
      </div>
    );
  }
}
